<template>
  <v-img
    v-bind="attrs"
    :src="normalizedSrc"
    :alt="alt"
    :height="height"
    :max-height="maxHeight"
    :cover="cover"
    :contain="contain"
    :lazy-src="lazySrc"
  >
    <template #placeholder>
      <div class="lazy-placeholder">
        <v-progress-circular indeterminate color="primary" size="28" />
      </div>
    </template>
  </v-img>
</template>

<script setup lang="ts">
import { computed, useAttrs } from 'vue';

defineOptions({ inheritAttrs: false });

const props = defineProps<{
  src?: string | null;
  alt?: string;
  height?: string | number;
  maxHeight?: string | number;
  cover?: boolean;
  contain?: boolean;
  lazySrc?: string;
}>();

const attrs = useAttrs();

const normalizedSrc = computed(() => props.src ?? undefined);
const lazySrc = computed(
  () =>
    props.lazySrc ??
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==',
);
</script>

<style scoped>
.lazy-placeholder {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  background: var(--surface-overlay);
}
</style>
